import { SerializedData } from 'bernie-core';
import { Store } from 'bernie-plugin-mobx';
import { Logger, NOOP_LOGGER } from 'bernie-logger';

export class ConfigStore extends Store {
  private glassbox: {
    reportUrl: string;
    src: string;
  };

  constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);
  }

  public hydrate(data: SerializedData): void {
    this.glassbox = data.glassbox;
  }
}
